import React from "react";
import { useSelector } from "react-redux";
import { LOCALES } from "../lang";

const ArrowDropDownIcon = ({ width, height, color }) => {
  const locale = useSelector(({ theme }) => theme.locale);

  return (
    <svg
      class="w-6 h-6 text-gray-800 dark:text-white"
      height={height}
      width={width}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      viewBox="0 0 24 24"
    >
      <path
        fill-rule="evenodd"
        d="M18.4 10.3A2 2 0 0 0 17 7H7a2 2 0 0 0-1.5 3.3l4.9 5.9a2 2 0 0 0 3 0l5-6Z"
        clip-rule="evenodd"
      />
    </svg>

    // <svg
    //   fill={color}
    //   height={height}
    //   width={width}
    //   version="1.1"
    //   id="Layer_1"
    //   viewBox="0 0 386.257 386.257"
    // >
    //   <polygon
    //     points="0,96.879 193.129,289.379 386.257,96.879 "
    //   />
    // </svg>
  );
};

export default ArrowDropDownIcon;
